import { render } from "./UserPwdCheckPopup.vue?vue&type=template&id=32ffecd6"
import script from "./UserPwdCheckPopup.vue?vue&type=script&lang=js"
export * from "./UserPwdCheckPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__